import React, { forwardRef, PropsWithChildren } from 'react';

import Link from 'next/link';

import { StyledAnchor, StyledButton } from './styles';

interface Props {
  ariaControls?: string;
  ariaExpanded?: boolean;
  isActive?: boolean;
  tabIndex?: number;
  openInNewTab?: boolean;
}

type ClickOrHref =
  | {
      onClick?: () => void;
      href?: undefined;
    }
  | {
      onClick?: undefined;
      href: string;
    };

export type NavigationMenuButtonProps = Props & ClickOrHref;

export const NavigationMenuButton = forwardRef<
  HTMLAnchorElement | HTMLButtonElement,
  PropsWithChildren<NavigationMenuButtonProps>
>(
  (
    {
      children,
      isActive,
      ariaControls,
      ariaExpanded,
      href,
      tabIndex,
      openInNewTab = false,
      onClick,
    },
    ref
  ) => {
    if (href) {
      return (
        <Link legacyBehavior passHref href={href}>
          <StyledAnchor
            ref={ref as React.Ref<HTMLAnchorElement>}
            data-disable-nprogress={true}
            isActive={isActive}
            tabIndex={tabIndex}
            target={openInNewTab ? '_blank' : undefined}
          >
            {children}
          </StyledAnchor>
        </Link>
      );
    }

    return (
      <StyledButton
        ref={ref as React.Ref<HTMLButtonElement>}
        aria-controls={ariaControls}
        aria-expanded={ariaExpanded}
        data-disable-nprogress={true}
        isActive={isActive}
        tabIndex={tabIndex}
        onClick={onClick}
      >
        {children}
      </StyledButton>
    );
  }
);

NavigationMenuButton.displayName = 'NavigationMenuButton';
